import axios from 'axios';
import qs from 'qs';
import { showLoading, hideLoading } from './loading';
import store from '../store';
import BASEURL from '../config/configBaseURL';
import getPlatformURL from '../config/platformBaseURL';

const axiosDefaultOptions = {};

const service = axios.create({
  // `method` 是创建请求时使用的方法
  method: 'post', // default
  // `baseURL` 将自动加在 `url` 前面，除非 `url` 是一个绝对 URL。
  // 它可以通过设置一个 `baseURL` 便于为 axios 实例的方法传递相对 URL
  baseURL: getPlatformURL() + '/mobilegw', // 测试环境
  // baseURL: '/mobilegw', // 开发调试
  // `url` 是用于请求的服务器 URL
  url: '/unicom',
  // `headers` 是即将被发送的自定义请求头
  headers: {
    'Content-Type': 'application/json;charset=utf-8'
  },
  // `timeout` 指定请求超时的毫秒数(0 表示无超时时间)
  timeout: 10000,
  // `withCredentials` 表示是否允许跨域访问
  withCredentials: true,
  // `data` 是作为请求主体被发送的数据
  // 只适用于这些请求方法 'PUT', 'POST', 和 'PATCH'
  // 在没有设置 `transformRequest` 时，必须是以下类型之一：
  // - string, plain object, ArrayBuffer, ArrayBufferView, URLSearchParams
  // - 浏览器专属：FormData, File, Blob
  // - Node 专属： Stream
  data: {},
  // `responseType` 表示服务器响应的数据类型，可以是 'arraybuffer', 'blob', 'document', 'json', 'text', 'stream'
  responseType: 'json', // 默认的
  // `maxContentLength` 定义允许的响应内容的最大尺寸
  maxContentLength: 20000,
  // `validateStatus` 定义对于给定的HTTP 响应状态码是 resolve 或 reject  promise 。如果 `validateStatus` 返回 `true` (或者设置为 `null` 或 `undefined`)，promise 将被 resolve; 否则，promise 将被 rejecte
  validateStatus(status) {
    return status >= 200 && status < 300; // 默认的
  },
  isShowLoading: true
});
service.interceptors.request.use(
  config => {
    if (!config.baseURL.includes('mobilegw-userCenter')) {
      config.baseURL = getPlatformURL() + '/mobilegw';
    }
    if (store.state.token) {
      config.headers.token = store.state.token;
    }
    if (config.isShowLoading) {
      showLoading();
    }
    return config;
  },
  ({ config }) => {
    if (config.isShowLoading) {
      hideLoading();
    }
    return 'error';
  }
);

service.interceptors.response.use(
  response => {
    const { config, status, data } = response;
    if (config.isShowLoading) {
      hideLoading();
    }
    if (response.data.code == '401' || response.data.code == '402') {
      store.commit('del_token');
      router.push({
        path: '/login',
        query: { redirect: router.currentRoute.fullPath } //登录成功后跳入浏览的当前页面
      });
    }
    if (status === 200) {
      return data;
    }
    return {
      status
    };
  },
  ({ config }) => {
    if (config.isShowLoading) hideLoading();
    return 'error';
  }
);

export function requestWWWForm(url, datas) {
  let oDatas = datas;
  const d = {
    ...datas
  };
  oDatas = qs.stringify(d);
  return service.post(url, oDatas, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    }
  });
}
export function requestJSONForm(url, datas) {
  let oDatas = datas;
  const d = {
    ...datas
  };
  oDatas = JSON.stringify(d);
  return service.post(url, oDatas, {
    headers: {
      'Content-Type': 'application/json; charset=UTF-8'
    }
  });
}

export function requestFileForm(url, datas) {
  return service.post(url, datas, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}

export function getRequestJSON(url, datas) {
  return service({
    method: 'get',
    url,
    params: datas,
    headers: {
      'Content-Type': 'application/json; charset=UTF-8'
    }
  });
}
